// Service detail content. Structured for rendering by ServicoDetail.
// Block types: p (paragraph), b (bold label + text), ul (bullet list), sub (sub-section)

const baseSections = (serviceName, focus, indications = []) => [
  {
    h: `O que é ${serviceName}?`,
    blocks: [
      { type: "p", text: focus },
    ],
  },
  {
    h: "Quando pode ser indicado?",
    blocks: [
      { type: "ul", items: indications },
    ],
  },
  {
    h: "Como funciona a avaliação?",
    blocks: [
      { type: "p", text: "A indicação do exame ou tratamento depende da consulta médica, avaliação dos sintomas, histórico clínico e, quando necessário, exames complementares." },
      { type: "p", text: "O objetivo é definir o diagnóstico com segurança e escolher a melhor conduta para cada paciente." },
    ],
  },
];

export const services = {
  "videonasofibroscopia": {
    title: "Videonasofibroscopia",
    image: "/images/consulta.png",
    intro: "Exame endoscópico utilizado para avaliar nariz, rinofaringe, adenoide e vias aéreas superiores.",
    sections: baseSections(
      "a Videonasofibroscopia",
      "É realizada com uma fibra óptica flexível, permitindo visualizar estruturas internas do nariz e garganta com precisão.",
      ["Obstrução nasal", "Rinite e sinusite", "Ronco e respiração oral", "Avaliação de adenoide", "Secreção nasal persistente"]
    ),
  },
  "videolaringoscopia": {
    title: "Videolaringoscopia",
    image: "/images/consulta.png",
    intro: "Exame para visualização da laringe e cordas vocais, indicado em alterações de voz, rouquidão e desconfortos na garganta.",
    sections: baseSections(
      "a Videolaringoscopia",
      "Permite avaliar a laringe, pregas vocais e estruturas próximas, auxiliando no diagnóstico de lesões, inflamações e alterações funcionais.",
      ["Rouquidão persistente", "Dor ou incômodo na garganta", "Alterações na voz", "Suspeita de lesões nas cordas vocais", "Acompanhamento pós-tratamento"]
    ),
  },
  "videoestroboscopia": {
    title: "Videoestroboscopia",
    image: "/images/consulta.png",
    intro: "Exame especializado para avaliação detalhada da vibração das cordas vocais.",
    sections: baseSections(
      "a Videoestroboscopia",
      "Utiliza luz estroboscópica para analisar a movimentação das pregas vocais, sendo muito útil na investigação de alterações vocais.",
      ["Rouquidão crônica", "Profissionais da voz", "Suspeita de nódulos, pólipos ou cistos", "Falhas ou cansaço vocal", "Acompanhamento de tratamento vocal"]
    ),
  },
  "tomografias": {
    title: "Tomografias",
    image: "/images/consulta.png",
    intro: "Exames de imagem que auxiliam na investigação de alterações dos seios da face, ouvido e estruturas da cabeça e pescoço.",
    sections: baseSections(
      "a Tomografia",
      "A tomografia fornece imagens detalhadas e ajuda no planejamento diagnóstico e cirúrgico em otorrinolaringologia.",
      ["Sinusite crônica", "Pólipos nasais", "Desvio de septo", "Doenças do ouvido", "Planejamento cirúrgico"]
    ),
  },
  "raio-x": {
    title: "Raio X",
    image: "/images/consulta.png",
    intro: "Exame radiológico complementar que pode auxiliar na avaliação inicial de algumas condições otorrinolaringológicas.",
    sections: baseSections(
      "o Raio X",
      "É um exame de imagem simples e rápido, usado conforme indicação médica para complementar a avaliação clínica.",
      ["Avaliação complementar", "Investigação de alterações anatômicas", "Acompanhamento conforme necessidade clínica"]
    ),
  },
  "audiometria-e-bera": {
    title: "Audiometria e BERA",
    image: "/images/medico.png",
    intro: "Exames usados para avaliar a audição e o funcionamento das vias auditivas.",
    sections: baseSections(
      "a Audiometria e o BERA",
      "A audiometria mede a capacidade auditiva. O BERA avalia respostas elétricas das vias auditivas e pode ser indicado em bebês, crianças ou casos específicos.",
      ["Perda auditiva", "Zumbido", "Triagem e investigação auditiva", "Avaliação infantil", "Acompanhamento de alterações auditivas"]
    ),
  },
  "exames-de-otoneurologia": {
    title: "Exames de Otoneurologia",
    image: "/images/medico.png",
    intro: "Exames voltados para investigação de tontura, vertigem, desequilíbrio e alterações do labirinto.",
    sections: baseSections(
      "os Exames de Otoneurologia",
      "Avaliam o sistema vestibular e ajudam a diferenciar causas de tontura e desequilíbrio.",
      ["Tontura", "Vertigem", "Desequilíbrio", "Náuseas relacionadas ao movimento", "Suspeita de alterações vestibulares"]
    ),
  },
  "exames-para-labirintopatias": {
    title: "Exames para Labirintopatias",
    image: "/images/medico.png",
    intro: "Avaliação direcionada para doenças do labirinto e sintomas vestibulares.",
    sections: baseSections(
      "os Exames para Labirintopatias",
      "São indicados para investigar alterações do labirinto, orientar o diagnóstico e definir o melhor tratamento.",
      ["Crises de vertigem", "Sensação de instabilidade", "Zumbido associado à tontura", "Náusea com movimento", "Histórico de labirintite ou labirintopatia"]
    ),
  },
  "imunoterapia-testes-alergicos": {
    title: "Imunoterapia e Testes Alérgicos",
    image: "/images/online.png",
    intro: "Avaliação e tratamento de alergias respiratórias, como rinite alérgica, por meio de testes e imunoterapia quando indicada.",
    sections: baseSections(
      "a Imunoterapia e os Testes Alérgicos",
      "Os testes ajudam a identificar sensibilidades alérgicas. A imunoterapia pode ser indicada para reduzir crises e melhorar o controle dos sintomas a longo prazo.",
      ["Rinite alérgica", "Espirros e coceira nasal", "Obstrução nasal recorrente", "Sintomas persistentes apesar do tratamento", "Suspeita de alergias respiratórias"]
    ),
  },
};

export const getService = (slug) => services[slug];

export const getServiceList = () =>
  Object.entries(services).map(([slug, value]) => ({ slug, title: value.title }));
